module.exports = __webpack_public_path__ + "assets/img/btn-detail-c100a12b.png";